import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {UtilService} from "../../shared/services/util.service";
import {ViewsService} from "../../shared/services/views.service";
import { FilterSelectComponent } from "../filter-select/filter-select.component";
import { MaterialModule } from "src/app/app.materials";
import { FormsModule } from '@angular/forms';
import { CleanNamePipe } from "../../shared/services/clean-name.pipe";
import { BenchmarkSelectorForViewsComponent } from '../benchmark-selector-for-views/benchmark-selector-for-views.component';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-views-setter',
  templateUrl: './views-setter.component.html',
  styleUrls: ['./views-setter.component.scss'],
  imports: [FilterSelectComponent, MaterialModule, FormsModule, CleanNamePipe, BenchmarkSelectorForViewsComponent, CommonModule],
  standalone: true,
})
export class ViewsSetterComponent implements OnInit {

  @Input() sectors: any[] = []
  @Input() countries: any[] = []
  @Input() assets: any[] = []
  @Input() benchmarks: any[] = []
  @Input() portfolio: any;
  @Input() views: any[] = []
  @Input() isSummary: boolean = false
  @Output() optimize = new EventEmitter();

  activeView: any = {};
  list: any[] = [];
  showOptimize = false;

  types = [
    { id: 'asset', name: 'Asset' },
    { id: 'sector', name: 'Sector' },
    { id: 'country', name: 'Country' },
    { id: 'index', name: 'Market Factors' }
  ];

  viewTypes = [
    { id: 'relative', name: 'Relative', disabledWithIndex: true},
    { id: 'absolute', name: 'Absolute', disabledWithIndex: false},
    { id: 'relative_market_equilibrium', name: 'Relative Market Equilibrium', disabledWithIndex: true},
  ];

  takes = [
    { id: 'outperform', name: 'Outperform'},
    { id: 'underperform', name: 'Underperform'},
  ];

  constructor(
    private util: UtilService,
    private service: ViewsService
  ) { }

  ngOnInit(): void {

  }

  onTypeChange() {
    this.list = [];
    delete this.activeView.items;
    switch (this.activeView.type) {
      case 'asset':
        this.list = this.assets;
        break;
      case 'sector':
        this.list = this.sectors;
        break;
      case 'country':
        this.list = this.countries;
        break;
      case 'index':
        this.list = this.benchmarks;
        break;
      default:
        this.list = [];
    }
  }

  onViewTypeChange() {
    if (this.activeView.view_type === 'absolute') {
      delete this.activeView.take;
      delete this.activeView.items2;
    }
  }

  initActiveView()
  {
    return {
      type: 'asset',
      portfolio_id: this.portfolio.id,
    }
  }

  onAddView() {
    this.saveView()
    this.activeView = this.initActiveView();
    this.list = this.assets;
    this.showOptimize = true;
  }

  saveView() {
    if (this.activeView.type && this.activeView.items) {
      // Convert benchmark to an array with id
      if (this.activeView.type === 'index') {
        this.activeView.items = [this.activeView.items.id]
      }

      this.service.create(this.activeView).subscribe(resp => {
        if (resp.error) {
          return this.service.notificationService.open(resp.error);
        }
        if (this.activeView.id) {
          this.views = this.util.findAndReplaceItemInArray(resp, this.views);
        } else {
          this.views.push(resp);
        }
        this.showOptimize = true;
        this.discardView();
      });
    }
  }

  editView(c) {
    this.activeView = {...c};
    this.activeView.type = c.type.id;

    this.onTypeChange();

    if (this.activeView.type === 'index') {
      if (c.items.length > 0) {
        c.items = c.items.map(i => {
          if (!i.name_full) {
            i.name_full = i.name; // fix benchmark selector name
          }
          return i;
        }); 
      }
      this.activeView.items = c.items[0];
    } else {
      this.activeView.items = c.items.map(i => +i.id);
    }
    this.activeView.items2 = c.items2.map(i => +i.id);
    this.activeView.portfolio_id = this.portfolio.id;
  }

  deleteView(v) {
    this.service.delete(v).subscribe(resp => {
      this.views = this.views.filter(viw => viw.id !== v.id);
      this.showOptimize = true;
    });
  }

  discardView() {
    this.activeView = {};
  }

}
